import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import BlurLoader from "./components/CommonComponents/BlurFullPageLoader";
import Header from "./components/Layout/Header";
import SideBar from "./components/Layout/SideBar";
import { GetSession, RemoveSession } from "./components/CommonComponents/cryptoUtils";

const Protected = (Props) => {
    const { Component } = Props;
    const navigate = useNavigate();
    const [auth, setAuth] = useState(false);
    const subLoading = useSelector(state => state.auth.loading)
    const { open } = useSelector((state) => state.header);

    const checkLogin = async () => {
        const Token = await GetSession('cookies', 'token');
        let LoginUserCode = await GetSession('cookies', 'loginUserCode');
        if (!Token || Token === 'EXPIRED') {
            RemoveSession('cookies', 'token')
            RemoveSession('cookies', 'loginUserCode')
            RemoveSession('cookies', 'userName')
            navigate('/');
            setAuth(false);
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            setAuth(true);
        }
    };
    useEffect(() => {
        checkLogin();
    }, [])

    return auth ? (
        <>
            <Header />
            <SideBar />
            <main id="main" className={`main ${open ? 'margin_left' : ''}`}>
                <Component />
            </main>
            {subLoading && <BlurLoader />}
        </>
    ) : <></>
}
export default Protected;